import { OrderType } from './../../enums/order-type.enum';
import { DictionaryValue } from './../dictionary/dictionaryValue';
import { BaseClass } from '../base-class';
import { Client } from '../client';
import { User } from '../user/user';
import { OrderStatus } from '@enums/order-status.enum';
import { Site } from '@classes/site';
import { OrderPatient } from './orderPatient';
import { OrderStatusChange } from './orderStatusChange';
import { OrderStep } from './orderStep';
import { Vehicle } from '@classes/vehicles/vehicle';

export class Order extends BaseClass {
  identifier: string;
  driver?: User;
  site: Site;
  urgency?: DictionaryValue;
  lot?: DictionaryValue;
  statusChanges: OrderStatusChange[];
  startDate?: Date;
  startedOn?: Date;
  dispatcherComment: string;
  sender: OrderStep;
  receivers: OrderStep[];
  ordererComment?: string;
  ordererPhone?: string;
  ordererName: string;
  status: OrderStatus;
  type: OrderType;
  callDate?: Date;
  timeSpent?: number;

  isDeleted?: boolean;
  transportVoucher?: string;


  transportTypes: DictionaryValue[];
  patients?: OrderPatient[];

  client?: Client;

  modifiedFields?: string[];

  tagScanned: string;
  arrivedOn?: Date;
  completedOn?: Date;
  scansPickedGroupedByContainer?: any = {};
  scansDeliveredGroupedByContainer?: any = {};

  isVerySoon?: boolean;

  vehicle?: Vehicle;

  price: number;

  constructor()
  constructor(
    site: Site,
    urgency: DictionaryValue,
    startDate: Date,
    ordererPhone: string,
    ordererName: string,
    sender: OrderStep,
    receivers: OrderStep[],
    transportTypes: DictionaryValue[],
    type: OrderType,
    ordererComment?: string,
    callDate?: Date,
    lot?: DictionaryValue)
  constructor(
    site?: Site,
    urgency?: DictionaryValue,
    startDate?: Date,
    ordererPhone?: string,
    ordererName?: string,
    sender?: OrderStep,
    receivers?: OrderStep[],
    transportTypes?: DictionaryValue[],
    type?: OrderType,
    ordererComment?: string,
    callDate?: Date,
    lot?: DictionaryValue) {
    super();

    this.site = site;
    this.urgency = urgency;
    this.startDate = startDate;
    this.ordererPhone = this.trim(ordererPhone);
    this.ordererName = this.trim(ordererName);
    this.sender = sender;
    this.receivers = receivers;
    this.ordererComment = this.trim(ordererComment);
    this.transportTypes = transportTypes;
    this.type = type;
    this.callDate = callDate;
    this.lot = lot;
  }

  static fromObject(object: Order): Order {
    return Object.assign(new Order(), {
      ...object,
      // driver: object.driver ? User.fromObject(object.driver) : null,
      site: object.site ? Site.fromObject(object.site) : null,
      urgency: object.urgency ? DictionaryValue.fromObject(object.urgency) : null,
      lot: object.lot ? DictionaryValue.fromObject(object.lot) : null,
      sender: object.sender ? OrderStep.fromObject(object.sender) : null,
      receivers: object.receivers?.map(r => OrderStep.fromObject(r)),
    });
  }

  get display(): string {
    return this.identifier;
  }
}
